module.exports = __webpack_public_path__ + "img/pethouse48.1fec48fa.jpg";